import React from 'react';
import Reveal from './Reveal';

const PageHeader = ({ eyebrow, title, children }) => (
  <section className="relative overflow-hidden border-b border-ink-700 pb-16 pt-36 md:pb-20 md:pt-44">
    <div className="grid-bg pointer-events-none absolute inset-0 [mask-image:linear-gradient(to_bottom,black,transparent)]" />
    <div className="container-site relative">
      <Reveal>
        <p className="eyebrow">{eyebrow}</p>
        <h1 className="mt-4 max-w-3xl font-display text-4xl font-bold leading-tight text-white md:text-6xl">{title}</h1>
        {children && <p className="mt-6 max-w-2xl text-lg leading-relaxed text-slate-400">{children}</p>}
      </Reveal>
    </div>
  </section>
);

export default PageHeader;
